module.exports = __webpack_public_path__ + "static/media/student-summary-record-next.ff144590.png";